module.exports = __WEBPACK_EXTERNAL_MODULE__opentelemetry_instrumentation__;